import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

export default function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => { track(loc.pathname); }, [loc.pathname]);
  useEffect(() => {
    const h = () => track(window.location.pathname);
    window.addEventListener("helium-consent-change", h);
    return () => window.removeEventListener("helium-consent-change", h);
  }, []);
  return null;
}
